export default {"src":"/_next/static/media/tokko-chat.5f60064d.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};